import { palette } from './palette';
import { defaultMuiTheme } from '@ccm-office/ccm-ui';
import { common } from '@material-ui/core/colors';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox';

/**
 * @TODO
 * - review these colors
 * - replace them with colors from palette
 * - remove COLORS constant
 */
const COLORS = {
  botticelli: '#CCE2E5',
  linkWater: '#CDD1D3',
  disabledInputsPlaceholder: '#9d9d9d',
  dateRange: '#eef0ff',
};

defaultMuiTheme.palette = {
  ...defaultMuiTheme.palette,
  background: {
    ...defaultMuiTheme.palette.background,
    default: common.white,
    paper: palette.background.quaternary,
    tertiary: palette.background.tertiary,
  },
  custom: {
    ...defaultMuiTheme.palette.custom,
    floater: COLORS.botticelli,
    border: palette.border.primary,
    buttonBorder: palette.border.primary,
    contentBorder: COLORS.linkWater,
    disabledInputsPlaceholder: COLORS.disabledInputsPlaceholder,
    dateRange: COLORS.dateRange,
  },
  error: {
    ...defaultMuiTheme.palette.error,
    main: palette.ui.red.main,
    dark: palette.ui.red['60'],
  },
  info: {
    ...defaultMuiTheme.palette.info,
    main: palette.ui.teal.main,
    dark: palette.ui.teal['60'],
  },
  warning: {
    ...defaultMuiTheme.palette.warning,
    main: palette.ui.orange.main,
    dark: palette.ui.orange['40'],
  },
  primary: {
    ...defaultMuiTheme.palette.primary,
    main: palette.uiPrimary.primary,
    light: palette.uiPrimary.secondary,
    dark: palette.uiPrimary.tertiary,
  },
  secondary: {
    ...defaultMuiTheme.palette.secondary,
    main: palette.uiPrimary.secondary,
    light: palette.uiPrimary.quaternary,
    dark: palette.uiPrimary.primary,
  },
  text: {
    ...defaultMuiTheme.palette.text,
    disabled: palette.text.tertiary,
    secondary: palette.text.secondary,
    tertiary: palette.text.tertiary,
  },
  fill: {
    primary: palette.fill.primary,
    secondary: palette.fill.secondary,
    tertiary: palette.fill.tertiary,
    quaternary: palette.uiPrimary.quaternary,
  },
};

defaultMuiTheme.typography = {
  ...defaultMuiTheme.typography,
  fontSize: 16,
  h1: {
    fontSize: '34px',
    fontWeight: 'normal',
    lineHeight: '40px',
    letterSpacing: '-0.05em',
  },
  h2: {
    fontSize: '28px',
    fontWeight: 'normal',
    lineHeight: '40px',
    letterSpacing: '-0.043em',
  },
  h3: {
    fontSize: '23px',
    fontWeight: 'normal',
    lineHeight: '32px',
    letterSpacing: '-0.028em',
  },
  h4: {
    fontSize: '19px',
    fontWeight: 'normal',
    lineHeight: '32px',
    letterSpacing: '-0.028em',
  },
  subtitle1: {
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: '16px',
    letterSpacing: '-0.06em',
  },
  subtitle2: {
    fontSize: '16px',
    fontWeight: 'normal',
    lineHeight: '24px',
    letterSpacing: '-0.06em',
  },
};

defaultMuiTheme.overrides = {
  ...defaultMuiTheme.overrides,
  MuiAppBar: {
    colorPrimary: {
      backgroundColor: common.white,
    },
  },
  MuiTypography: {
    h3: {
      padding: '16px 0px',
    },
  },
  MuiButton: {
    root: {
      ...defaultMuiTheme.overrides?.MuiButton?.root,
      textTransform: 'capitalize',
    },
  },
  MuiChip: {
    root: {
      ...defaultMuiTheme.overrides?.MuiChip?.root,
      borderRadius: '20px',
    },
  },
  MuiInputAdornment: {
    root: {
      color: defaultMuiTheme.palette.action.active,
    },
  },
};

defaultMuiTheme.props = {
  MuiCheckbox: {
    icon: <CheckBoxOutlineBlankIcon />,
    checkedIcon: <CheckBoxIcon />,
    indeterminateIcon: <IndeterminateCheckBoxIcon />,
  },
  MuiRadio: {
    icon: <RadioButtonUncheckedIcon />,
    checkedIcon: <RadioButtonCheckedIcon />,
  },
  MuiButton: {
    disableRipple: true,
  },
};

declare module '@material-ui/core/styles/createPalette' {
  interface Palette {
    custom: {
      floater: React.CSSProperties['color'];
      border: React.CSSProperties['color'];
      tableBorder: React.CSSProperties['color'];
      buttonBorder: React.CSSProperties['color'];
      contentBorder: React.CSSProperties['color'];
      disabledInputsPlaceholder: React.CSSProperties['color'];
      dateRange: React.CSSProperties['color'];
    };
  }
  interface PaletteOptions {
    custom: {
      floater: React.CSSProperties['color'];
      border: React.CSSProperties['color'];
      tableBorder: React.CSSProperties['color'];
      buttonBorder: React.CSSProperties['color'];
      contentBorder: React.CSSProperties['color'];
      disabledInputsPlaceholder: React.CSSProperties['color'];
      dateRange: React.CSSProperties['color'];
    };
  }

  interface TypeBackground {
    tertiary: string;
  }

  interface TypeText {
    tertiary: string;
  }

  interface Palette {
    fill: {
      primary: string;
      secondary: string;
      tertiary: string;
      quaternary: string;
    };
  }
}

export { defaultMuiTheme };
